import React, { useState, useEffect, useContext } from "react";
import { GlobalContext } from "../context/GlobalContext";
import ValidationMessages from "../common/ValidationMessages";
import Autocomplete, { createFilterOptions } from "@mui/material/Autocomplete";
import { makeStyles } from "@mui/styles";
import { TextField } from "@mui/material";
import CheckIcon from "@mui/icons-material/Check";
import EditIcon from "@mui/icons-material/Edit";
import Button from "@mui/material/Button";
import { Paper, Typography } from "@mui/material";
import options from "./SkillOptionsData";
import api from "components/settings/api";
import { useAuth } from "components/context/auth";
import { Bounce, toast, ToastContainer } from "react-toastify";
import CustomToastMessage from "components/common/CustomToastMessage";
import SkillTagInput from "../modals/SkillTagInput";
import Cookies from "js-cookie";
import { color } from "@mui/system";
import cities from "../../data/us-city-states.json";

const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
    "& > *": {
      width: "36ch",
      margin: theme.spacing(1),
      marginTop: "15px",
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      [theme.breakpoints.down("md")]: {
        padding: "0",
        width: "97%",
      },
      [theme.breakpoints.down("sm")]: {
        width: "96%",
      },
    },
  },
  input: {
    width: "calc(100% - 1em)",
    position: "relative",
    "& > *": {
      margin: theme.spacing(1),
      width: "90%",
      marginTop: "15px",
      [theme.breakpoints.down("md")]: {
        padding: "0",
        width: "90%",
      },
    },
  },
  skills: {
    width: "calc(100% - 1em)",
    position: "relative",
    "& > *": {
      margin: theme.spacing(1),
      width: "90%",
      marginTop: "15px",
      [theme.breakpoints.down("md")]: {
        padding: "0",
        width: "90%",
      },
    },
  },
  editProfileContainer: {width: "calc(100% - 1em)"},
  edit: {
    cursor: "pointer",
    color: "#00a682",
  },
  delete: {
    display: "flex",
    justifyContent: "center",
    maxWidth: "90%",
    marginLeft: "auto",
    marginRight: "auto",
    color: "red",
    cursor: "pointer",
    "&:hover": {
      color: "#C12807",
    },
  },
  container: {
    display: "flex",
    justifyContent: "center",
    width: "100%",
  },
}));

const UserInfo = (props) => {
  const { setUser, user } = useAuth();
  const appState = useContext(GlobalContext);
  const {
    loading,
    setLoadingState,
    reloadThisData,
    setWhatToReload,
    updateUserData,
  } = appState;
  const [formInputs, setFormInputs] = useState({
    email: "",
    fullname: "",
    location: "",
    institution: "",
    major: "",
    bio: "",
    webpage: "",
    linkedin: "",
    profession: "",
  });
  const [Skills, setSkills] = useState([]);
  const [skillInput, setSkillInput] = useState([]);
  const [skillValues, setSkillValues] = useState([]);
  const [showErrors, setShowErrors] = useState(false);
  const [errorsArr, setErrorsArr] = useState();
  const [editable, setEditable] = useState(false);
  const [profileEditable, setProfileEditable] = useState(false);
  const [openModal, setOpenModal] = useState(false);
  const [isVerified, setIsVerified] = useState(false);
  const [firstLoad, setFirstLoad] = useState(true);

  useEffect(() => {
    if (user) {
      setIsVerified(user.verifiedDT !== null);
    }

    const { profileData } = props;

    if (profileData) {
      if (firstLoad) {
        setFormInputs({
          email: profileData.email,
          fullname: profileData.fullname,
          location: profileData.location,
          institution: profileData.institution,
          major: profileData.major,
          bio: profileData.bio,
          webpage: profileData.webpage,
          linkedin: profileData.linkedin,
          profession: profileData.gender,
        });
        setFirstLoad(false);
      } else {
        setFormInputs({
          ...formInputs,
        });
      }

      if (user.Skills.length >= 0) {
        const filteredSkills = profileData.Skills.map(
          (item) => item.skill
        ).filter((skill) => skill !== "undefined" && skill !== undefined);

        setSkills(filteredSkills);

        setSkillValues(
          (filteredSkills[0] || "Your Skills") +
            `\n` +
            (filteredSkills[1] || "") +
            `\n` +
            (filteredSkills[2] || "")
        );
      }
    }
  }, [props.profileData, editable, user, skillInput]);

  const updateDB = async () => {
    let updatedSkills = [...skillInput.split(",")];
    try {
      setLoadingState(true);
      await api
        .put("/api/v1/profiles/profile", {
          email: formInputs.email,
          fullname: formInputs.fullname,
          location: formInputs.location,
          webpage: formInputs.webpage,
          bio: formInputs.bio,
          linkedin: formInputs.linkedin,
          institution: formInputs.institution,
          gender: formInputs.profession,
          major: formInputs.major,
          skillone: updatedSkills[0] || "",
          skilltwo: updatedSkills[1] || "",
          skillthree: updatedSkills[2] || "",
        })
        .then(async (res) => {
          // Clear any errors
          setErrorsArr([]);
          // Hide the errors component
          setShowErrors(false);
          await api
            .get("/api/v1/profiles/profile")
            .then((res) => {
              const { data } = res;
              if (data) {
                setUser(data);
                updateUserData(data);
              }
            })
            .catch((err) => {
              console.error(err);
              throw new Error(err);
            });
        })
        .catch((err) => {
          setErrorsArr(err);
          setShowErrors(true);
        });
      setLoadingState(false);
    } catch (err) {
      throw new Error(err);
    }
  };
  /*This state controls whether the CreatedPlayer component will mount. */
  const [showCreatedPlayerComponent, setCreatedPlayerMountingFlag] =
    useState(false);
  /*This state contains the player profiles this user has created.*/
  const [createdPlayers, setCreatedPlayersData] = useState([]);
  /*This methods fetches the players the current user has added.*/
  const fetchPlayersProfiles = () => {
    api
      .get("/api/v1/profiles/players")
      .then((res) => {
        const playersProjectCreatedCount = res.data.length;
        /*Update mounting state and data if available*/
        if (playersProjectCreatedCount > 0) {
          /*Tell react to mount*/
          setCreatedPlayerMountingFlag(true);
          /*Set data to state*/
          setCreatedPlayersData(res.data);
        } else if (
          playersProjectCreatedCount === 0 &&
          showCreatedPlayerComponent === true
        ) {
          /*Tell react to no longer mount the component.*/
          setCreatedPlayerMountingFlag(false);
        }
      })
      .catch((err) => {
        throw new Error(err);
      });
  };
  useEffect(() => {
    setLoadingState(true);
    if (loading) {
      setWhatToReload("userData");
    } else {
      setLoadingState(true);
    }
  }, [reloadThisData]);

  const validateUrl = (value, type) => {
    const isValidWebpage = value === "" || urlPattern.test(value);
    let isValidLinkedin =
      value === "" ||
      (urlPattern.test(value) &&
        value.includes("https://www.linkedin.com/in/"));
    if (type === "webpage") {
      setIsWebpageValid(isValidWebpage);
    } else if (type === "linkedin") {
      // If it's a LinkedIn URL, check for the specific user profile pattern
      setIsLinkedinValid(isValidLinkedin);
    }
  };

  const handleChange = (event) => {
    const { name, value } = event.target;
    const cleanedValue =
      typeof value === "string"
        ? name === "fullname"
          ? value.replace(/[^a-zA-Z ]/, "")
          : value.replace(/['"&]+/g, "")
        : "";
    setFormInputs((prevState) => ({
      ...prevState,
      [name]: cleanedValue,
    }));
    if (name === "webpage") {
      validateUrl(cleanedValue, "webpage");
    }
    if (name === "linkedin") {
      validateUrl(cleanedValue, "linkedin");
    }
  };

  const handleEdit = () => {
    if (editable === true) {
      handleEditEmail();
      setEditable(false);
    } else {
      setEditable(true);
    }
  };

  const handleEditEmail = async () => {
    const res = await api.get("/api/v1/profiles/profile");
    const prevEmail = res.data.email;
    const updatedEmail = formInputs.email;
    if (updatedEmail === prevEmail) {
      info("No changes made");
      return;
    } else {
      try {
        await api.put("/api/v1/profiles/profile/email", {
          currentEmail: prevEmail,
          newEmail: formInputs.email,
        });
      } catch (err) {
        console.log(err);
      }
      if (res.data.validationErrors === undefined) {
        // Clear any errors
        setErrorsArr([]);
        // Hide the errors component
        setShowErrors(false);
        api
          .get("/api/v1/profiles/profile")
          .then((res) => {
            const { data } = res;
            if (data) {
              setUser(data);
              updateUserData(data);
            }
          })
          .catch((err) => {
            throw new Error(err);
          });
      } else {
        // Set errors
        setErrorsArr(res.data.validationErrors.errors);
        // Show the errors component
        setShowErrors(true);
      }
      sendNewEmail(updatedEmail);
      setLoadingState(false);
    }
  };

  const handleEditProfile = () => {
    if (profileEditable === true) {
      updateDB();
      success("Profile Saved");
      setProfileEditable(false);
    } else {
      setProfileEditable(true);
    }
  };

  const sendNewEmail = async (email) => {
    const payload = {
      id: user.id,
      fullname: user.fullname,
      email: email,
    };
    try {
      await api.post("/api/v1/users/new/verify", payload);
      success("Verification Email Sent");
    } catch (err) {
      console.log(err.message);
    }
  };

  const modal = () => {
    if (openModal === true) {
      // toast modal
      <ToastContainer closeButton="Cancel"></ToastContainer>;
      setOpenModal(false);
    } else {
      setOpenModal(true);
    }
  };

  const classes = useStyles();
  const CHARACTER_LIMIT = 250;
  const THIRTYCHAR_LIMIT = 30;
  const FORTYCHAR_LIMIT = 40;
  const FIFTYCHAR_LIMIT = 50;
  const TWENTYFIVECHAR_LIMIT = 25;
  const [optionsApi, setoptionsApi] = useState([]);
  useEffect(() => {
    try {
      api.get("/api/v1/profiles/skills").then((item) => {
        setoptionsApi(item?.data);
      });
    } catch (error) {}
  }, []);

  const notify = (message) =>
    toast.error(<CustomToastMessage message={message} />, {
      autoClose: 2000,
      closeButton: true,
      hideProgressBar: false,
      transition: Bounce,
      position: "bottom-center",
    });

  const info = (message) =>
    toast.info(<CustomToastMessage message={message} />, {
      autoClose: 2000,
      closeButton: true,
      hideProgressBar: false,
      transition: Bounce,
      position: "bottom-center",
    });

  const success = (message) =>
    toast.success(<CustomToastMessage message={message} />, {
      autoClose: 2000,
      closeButton: true,
      hideProgressBar: false,
      transition: Bounce,
      position: "bottom-center",
    });

  const filter = createFilterOptions();

  const filterOptions = createFilterOptions({
    matchFrom: "start",
    stringify: (option) => option.title || "",
  });

  useEffect(() => {}, [Skills]);

  const checkData = (value) => {
    let reformatedItem = [];
    value?.map((item) => {
      if (item.split(`"Press Enter To add" `)[0] == "") {
        reformatedItem.push(item.split(`"Press Enter To add" `)[1]);
      } else {
        reformatedItem.push(item);
      }
    });
    setSkills(reformatedItem);
  };

  const [isWebpageValid, setIsWebpageValid] = useState(true);
  const [isLinkedinValid, setIsLinkedinValid] = useState(true);

  // Regular expression for URL validation
  const urlPattern = new RegExp(
    "^(https?:\\/\\/)?" + // protocol
      "((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|" + // domain name and extension
      "((\\d{1,3}\\.){3}\\d{1,3}))" + // OR ip (v4) address
      "(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*" + // port and path
      "(\\?[;&a-z\\d%_.~+=-]*)?" + // query string
      "(\\#[-a-z\\d_]*)?$",
    "i"
  ); // fragment locator

  // Function to validate the webpage URL
  const validateWebpage = (value) => {
    // Check if the value is either empty or a valid URL
    const isValid = value === "" || urlPattern.test(value);
    setIsWebpageValid(isValid);
  };

  const [locationValue, setLocationValue] = useState(formInputs.location || "");

  return (
    <div className={classes.container}>
      <form className={classes.root}>
        {showErrors && <ValidationMessages errorsArr={errorsArr} />}
        <div className={classes.input} noValidate autoComplete="on">
          {!editable ? (
            <TextField
              disabled
              value={formInputs.email}
              InputProps={{
                endAdornment: isVerified ? (
                  <></>
                ) : (
                  <EditIcon
                    onClick={handleEdit}
                    sx={{
                      cursor: "pointer",
                    }}
                    className="save-icon-profile"
                  ></EditIcon>
                ),
              }}
            ></TextField>
          ) : (
            <TextField
              InputProps={{
                endAdornment: isVerified ? (
                  <></>
                ) : (
                  <CheckIcon
                    onClick={handleEdit}
                    sx={{
                      cursor: "pointer",
                    }}
                    className="save-icon-profile"
                  ></CheckIcon>
                ),
              }}
              type="text"
              name="email"
              value={formInputs.email}
              onChange={handleChange}
            ></TextField>
          )}
        </div>
        <div className={classes.editProfileContainer}>
          {profileEditable ? (
            // <Typography className={classes.edit} onClick={handleEditProfile} disabled={!isWebpageValid || !isLinkedinValid}>
            //   Save Profile
            // </Typography>
            <Button
              variant="contained"
              color="primary"
              onClick={handleEditProfile}
              disabled={!isWebpageValid || !isLinkedinValid}
              aria-label="Save Profile"
            >
              Save Profile
            </Button>
          ) : (
            <Typography className={classes.edit} onClick={handleEditProfile} aria-label="Edit Profile">
              Edit Profile
            </Typography>
          )}
        </div>
        {profileEditable ? (
          <>
            <div className={classes.input} noValidate autoComplete="on">
              <TextField
                type="text"
                name="fullname"
                value={formInputs.fullname}
                onChange={handleChange}
                aria-label="Full name"
                label="Full name"
                inputProps={{
                  maxLength: TWENTYFIVECHAR_LIMIT,
                }}
              />
              {/* <div className="save-icon-profile-container">
                  <CheckIcon className="save-icon-profile" />
                </div> */}
            </div>
            <div className={classes.input} noValidate autoComplete="on">
              <TextField
                type="text"
                name="profession"
                value={formInputs.profession || ""}
                onChange={handleChange}
                label="Profession"
                aria-label="Profession"
                inputProps={{
                  maxLength: TWENTYFIVECHAR_LIMIT,
                }}
              />
            </div>
            <div className={classes.input} noValidate autoComplete="on">
              <Autocomplete
                freeSolo
                value={formInputs.location}
                onChange={(event, newValue) => {
                  setFormInputs((prev) => ({ ...prev, location: newValue }));
                }}
                inputValue={locationValue}
                onInputChange={(event, newInputValue) => {
                  setLocationValue(newInputValue);
                }}
                options={cities.map((city) => `${city.city}, ${city.state}`)}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Location"
                    variant="outlined"
                    inputProps={{
                      ...params.inputProps,
                      maxLength: THIRTYCHAR_LIMIT,
                    }}
                  />
                )}
              />
              {/* <TextField
                onChange={handleChange}
                onBlur={handleBlur}
                label="Location"
                value={formInputs.location}
                type="text"
                name="location"
                inputProps={{
                  maxLength: THIRTYCHAR_LIMIT,
                }}
              /> */}
              {/* <div className="save-icon-profile-container">
                  <CheckIcon className="save-icon-profile" />
                </div> */}
            </div>
            <div className={classes.input} noValidate autoComplete="on">
              <TextField
                type="text"
                name="institution"
                value={formInputs.institution}
                onChange={handleChange}
                label="Your University"
                aria-label="University"
                inputProps={{
                  maxLength: FORTYCHAR_LIMIT,
                }}
              />
              {/* <div className="save-icon-profile-container">
                  <CheckIcon className="save-icon-profile" />
                </div> */}
            </div>
            <div className={classes.input} noValidate autoComplete="off">
              <TextField
                value={formInputs.major}
                onChange={handleChange}
                label="Your Major"
                name="major"
                type="text"
                aria-label="Major"
                inputProps={{
                  maxLength: THIRTYCHAR_LIMIT,
                }}
              />
              {/* <div className="save-icon-profile-container">
                  <CheckIcon className="save-icon-profile" />
                </div> */}
            </div>
            <div className={classes.input} noValidate autoComplete="off">
              <TextField
                value={formInputs.webpage}
                onChange={handleChange}
                error={!isWebpageValid}
                helperText={
                  !isWebpageValid && "Please enter a valid webpage URL."
                }
                label="Your Webpage"
                name="webpage"
                aria-label="Webpage"
                type="url"
                inputProps={{
                  maxLength: FIFTYCHAR_LIMIT,
                }}
              />
              {/* <div className="save-icon-profile-container">
                  <CheckIcon className="save-icon-profile" />
                </div> */}
            </div>
            <div className={classes.input} noValidate autoComplete="off">
              <TextField
                value={formInputs.linkedin}
                onChange={handleChange}
                error={!isLinkedinValid}
                helperText={
                  !isLinkedinValid
                    ? "Please enter a valid LinkedIn user profile URL."
                    : ""
                }
                label="Your LinkedIn"
                name="linkedin"
                type="url"
                aria-label="Valid LinkedIn profile url"
                inputProps={{
                  maxLength: CHARACTER_LIMIT, // ?? this is 250 characters long for linkedin url ?? //
                }}
              />
              {/* <div className="save-icon-profile-container">
                  <CheckIcon className="save-icon-profile" />
                </div> */}
            </div>
            <div className={classes.skills}>
              <SkillTagInput
                skill={Skills}
                setSkillInput={setSkillInput}
                handleChange={handleChange}
              />
            </div>
            <div className={classes.input} noValidate autoComplete="off">
              <TextField
                value={formInputs.bio || ""}
                onChange={handleChange}
                name="bio"
                label="Bio"
                variant="outlined"
                placeholder="Write something :-)"
                multiline={true}
                aria-label="user bio"
                rows="5"
                inputProps={{
                  maxLength: CHARACTER_LIMIT,
                }}
                helperText={
                  formInputs.bio
                    ? `${formInputs.bio.length}/${CHARACTER_LIMIT}`
                    : `${0}/${CHARACTER_LIMIT}`
                }
              />
              {/* <div className="save-icon-profile-container">
                  <CheckIcon className="save-icon-profile" />
                </div> */}
            </div>
            <div className={classes.root}>
              <div className={classes.editProfileContainer}>
                <Button
                  variant="contained"
                  color="primary"
                  onClick={handleEditProfile}
                  disabled={!isWebpageValid || !isLinkedinValid}
                  aria-label="Save Profile"
                >
                  Save Profile
                </Button>
              </div>
            </div>
          </>
        ) : (
          <>
            <div className={classes.input} noValidate autoComplete="on">
              <TextField
                disabled
                type="text"
                name="fullname"
                aria-label="Full Name"
                value={formInputs.fullname}
                label="Full name"
                inputProps={{
                  maxLength: TWENTYFIVECHAR_LIMIT,
                }}
              />
              {/* <div className="save-icon-profile-container">
                  <CheckIcon className="save-icon-profile" />
                </div> */}
            </div>

            <div className={classes.input} noValidate autoComplete="on">
              <TextField
                disabled
                type="text"
                name="profession"
                value={formInputs.profession || ""}
                label="Profession"
                aria-label="Profession"
                inputProps={{
                  maxLength: TWENTYFIVECHAR_LIMIT,
                }}
              />
              {/* <div className="save-icon-profile-container">
                  <CheckIcon className="save-icon-profile" />
                </div> */}
            </div>

            <div className={classes.input} noValidate autoComplete="on">
              <TextField
                disabled
                label="Location"
                value={formInputs.location || ""}
                type="text"
                name="location"
                aria-label="location"
                inputProps={{
                  maxLength: THIRTYCHAR_LIMIT,
                }}
              />
              {/* <div className="save-icon-profile-container">
                  <CheckIcon className="save-icon-profile" />
                </div> */}
            </div>
            <div className={classes.input} noValidate autoComplete="on">
              <TextField
                disabled
                type="text"
                name="institution"
                value={formInputs.institution}
                label="Your University"
                aria-label="university"
                inputProps={{
                  maxLength: FORTYCHAR_LIMIT,
                }}
              />
              {/* <div className="save-icon-profile-container">
                  <CheckIcon className="save-icon-profile" />
                </div> */}
            </div>
            <div className={classes.input} noValidate autoComplete="off">
              <TextField
                disabled
                value={formInputs.major}
                label="Your Major"
                name="major"
                aria-label="Your Major"
                type="text"
                inputProps={{
                  maxLength: THIRTYCHAR_LIMIT,
                }}
              />
              {/* <div className="save-icon-profile-container">
                  <CheckIcon className="save-icon-profile" />
                </div> */}
            </div>
            <div className={classes.input} noValidate autoComplete="off">
              <TextField
                disabled
                value={formInputs.webpage}
                label="Your Webpage"
                name="webpage"
                aria-label="Webpage"
                inputProps={{
                  maxLength: FIFTYCHAR_LIMIT,
                }}
              />
              {/* <div className="save-icon-profile-container">
                  <CheckIcon className="save-icon-profile" />
                </div> */}
            </div>
            <div className={classes.input} noValidate autoComplete="off">
              <TextField
                disabled
                value={formInputs.linkedin}
                label="Your LinkedIn"
                name="linkedin"
                aria-label="LinkedIn profile url"
                inputProps={{
                  maxLength: CHARACTER_LIMIT, // ?? this is 250 characters long for linkedin url ?? //
                }}
              />
              {/* <div className="save-icon-profile-container">
                  <CheckIcon className="save-icon-profile" />
                </div> */}
            </div>
            <div className={classes.skills}>
              <TextField
                disabled
                value={skillValues}
                name="skills"
                label="Skills"
                aria-label="Skills"
                variant="outlined"
                multiline={true}
                rows="3"
              ></TextField>
            </div>
            <div className={classes.input} noValidate autoComplete="off">
              <TextField
                disabled
                value={formInputs.bio || ""}
                name="bio"
                label="Bio"
                variant="outlined"
                placeholder="Write something :-)"
                multiline={true}
                aria-label="Bio"
                rows="5"
                inputProps={{
                  maxLength: CHARACTER_LIMIT,
                }}
                helperText={
                  formInputs.bio
                    ? `${formInputs.bio.length}/${CHARACTER_LIMIT}`
                    : `${0}/${CHARACTER_LIMIT}`
                }
              />
              {/* <div className="save-icon-profile-container">
                  <CheckIcon className="save-icon-profile" />
                </div> */}
            </div>
          </>
        )}
      </form>
    </div>
  );
};
export default UserInfo;
